import { VariantProps, cva } from 'cva';

import { BodyProps } from '../Typography/Body/Body.styles';

export type TagProps = { label: string; size?: BodyProps['size'] } & VariantProps<typeof tagVariants>;

export const tagVariants = cva(`rounded-4`, {
  variants: {
    color: {
      secondary: 'bg-color-background-secondary',
    },
    size: {
      xlarge: 'px-4 py-2',
      large: 'px-4 py-2',
      medium: 'px-4 py-2',
      small: 'px-4 py-2',
      xsmall: 'px-4 py-1',
    },
  },
  defaultVariants: {
    color: 'secondary',
  },
});
